// import OffersPage from "@/app/features/offers/offers-page";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Events, scroller } from "react-scroll";
import WorkflowSteps from "./components/work-flow-time-line";
import OffersPage from "../offers";
import HeaderPage from "./components/header-page";
import PaymentMethods from "./components/payment-methods";
import PlatformFeatures from "./components/specifications-page";
import Footer from "@/layouts/footer";
import NavPage from "@/layouts/nav-header";

function LandingPage() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.hash === "#latestOpportunities") {
      scroller.scrollTo("latestOpportunities", {
        duration: 900,
        delay: 0,
        smooth: "easeInOutQuart",
      });
      Events.scrollEvent.register("end", () => {
        navigate(location.pathname, { replace: true }); // Remove the hash
      });
    }
  }, [location, navigate]);
  return (
    <>
      <NavPage isForm={1}>
        <div
          className="flex flex-col w-full min-h-screen"
          style={{ background: "#f8fafa !important", paddingTop: 80 }}
        >
          <HeaderPage />
          <WorkflowSteps />
          <PaymentMethods />
          <OffersPage />
          <PlatformFeatures />
          <Footer />
        </div>
      </NavPage>
    </>
  );
}

export default LandingPage;
